import Echo from 'laravel-echo';
import store from '@app/store';
import BPCMessageService from '@core/services/bpc-messages.service';
import { Channel } from 'laravel-echo/dist/channel';

window.Pusher = require('pusher-js');

export default class BPCEchoService {
  private bpcMessageService;

  constructor() {
    console.log('creating new instance of BPCEchoService');

    this.bpcMessageService = new BPCMessageService();

    window.Echo = new Echo({
      broadcaster: 'reverb',
      key: process.env.VUE_APP_BROADCAST_BPC_PUSHER_APP_KEY,
      auth: { headers: { Authorization: 'Bearer ' + store.getters['auth/authToken'] } },
      // authEndpoint: 'http://bepluscenters-api.test/api/v1/auth/check-endpoint',
      wsHost: process.env.VUE_APP_PUSHER_HOSTNAME,
      wsPort: process.env.VUE_APP_PUSHER_PORT,
      disableStats: true,
      forceTLS: false,
      enabledTransports: ['ws', 'wss'],
    });
  }

  listenUpdateCenterSettings() {
    const tenant = store.getters['tenant/selectedTenantId'];
    window.Echo.channel(`centerSettings.${tenant}`).listen(
      '.BPC\\Core\\Events\\UpdateCenterSettingsEvent',
      e => {
        if (store.getters['auth/isLoggedIn'] === true) {
          store.commit('centerSettings/updateCenterSettings', e.center_settings);
        }
      },
    );
  }

  getTerminalPaymentChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.channel(`terminal-payments.${tenant}`);
  }
  leaveTerminalPaymentChannel() {
    console.log('leave payment channel');
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.leave(`terminal-payments.${tenant}`);
  }
  getInvoiceGenerationChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`invoice-generation.${tenant}.${sessionCode}`);
  }
  leaveInvoiceGenerationChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`invoice-generation.${tenant}.${sessionCode}`);
  }
  getInvoiceValidationChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`invoice-validation.${tenant}.${sessionCode}`);
  }
  leaveInvoiceValidationChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`invoice-generation.${tenant}.${sessionCode}`);
  }
  getMarkInvoicesAsPaidChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`invoice-mark-as-paid.${tenant}.${sessionCode}`);
  }
  leaveMarkInvoicesAsPaidChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`invoice-mark-as-paid.${tenant}.${sessionCode}`);
  }
  getRenewBookingsChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`renew-bookings.${tenant}.${sessionCode}`);
  }
  leaveRenewBookingsChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`renew-bookings.${tenant}.${sessionCode}`);
  }
  getGenerateSessionsChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`generate-sessions.${tenant}.${sessionCode}`);
  }
  leaveGenerateSessionsChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`generate-sessions.${tenant}.${sessionCode}`);
  }
  getDownloadInvoicesChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`download_invoices.${tenant}.${sessionCode}`);
  }
  leaveDownloadInvoicesChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`download_invoices.${tenant}.${sessionCode}`);
  }

  leaveUpdateCenterSettings() {
    const tenant = store.getters['tenant/selectedTenantId'];
    window.Echo.leave(`centerSettings.${tenant}`);
  }

  getAddTicketToDirectDebitFileChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`add-ticket-to-direct-debit-file.${tenant}.${sessionCode}`);
  }

  getOnlinePaymentStatusChannel(paymentId): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`online-payment-status.${tenant}.${paymentId}`);
  }

  leaveOnlinePaymentStatusChannel(paymentId) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`online-payment-status.${tenant}.${paymentId}`);
  }

  leaveAddTicketToDirectDebitFileChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`add-to-direct-debit-file.${tenant}.${sessionCode}`);
  }

  getExportDirectDebitFileChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`export-direct-debit-file.${tenant}.${sessionCode}`);
  }
  leaveExportDirectDebitFileChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`export-direct-debit-file.${tenant}.${sessionCode}`);
  }
  getDirectDebitFileItemsUpdatedChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`direct_debit_file_items_updated.${tenant}.${sessionCode}`);
  }
  leaveDirectDebitFileItemsUpdatedChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`direct_debit_file_items_updated.${tenant}.${sessionCode}`);
  }

  listenNewMessages() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const contactId = store.getters['auth/contactId']({ tenantId: tenant });

    window.Echo.channel(`messages.tenant_${tenant}.contact_${contactId}`).listen(
      '.BPC\\Communications\\Events\\CreatedMessageEvent',
      e => {
        if (store.getters['auth/isLoggedIn'] === true) {
          store.dispatch('message/getMessages');
          this.bpcMessageService.showInfoMessage({ text: 'global.generic.new_message' });
          this.bpcMessageService.showInfoMessage({ text: e.messageTitle });
        }
      },
    );
  }

  leaveNewMessages() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const contactId = store.getters['auth/contactId']({ tenantId: tenant });

    window.Echo.leave(`messages.tenant_${tenant}.contact_${contactId}`);
  }

  getInvoiceSyncChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.channel(`invoice-sync.${tenant}.${sessionCode}`);
  }

  leaveInvoiceSyncChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.leave(`invoice-sync.${tenant}.${sessionCode}`);
  }

  getSaleDaySyncChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.channel(`sale-day-sync.${tenant}.${sessionCode}`);
  }

  leaveSaleDaySyncChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.leave(`sale-day-sync.${tenant}.${sessionCode}`);
  }

  getPaymentSyncChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.channel(`payment-sync.${tenant}.${sessionCode}`);
  }

  leavePaymentSyncChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    // return window.Echo.channel(`confirmed-terminal-payments.${tenant}.${paymentId}`);
    return window.Echo.leave(`payment-sync.${tenant}.${sessionCode}`);
  }

  listenExportDirectDebitChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`export-direct-debit-files.${tenant}.${sessionCode}`);
  }

  leaveExportDirectDebitChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`export-direct-debit-files.${tenant}.${sessionCode}`);
  }

  listenMoveToTrashChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`bulk-move-to-trash.${tenant}.${sessionCode}`);
  }

  leaveMoveToTrashChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`bulk-move-to-trash.${tenant}.${sessionCode}`);
  }

  listenRecoverChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`bulk-recover.${tenant}.${sessionCode}`);
  }

  leaveRecoverChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`bulk-recover.${tenant}.${sessionCode}`);
  }

  listenExportChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`export-generation.${tenant}.${sessionCode}`);
  }

  leaveExportChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`export-generation.${tenant}.${sessionCode}`);
  }

  listenBulkEditChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`bulk-edit.${tenant}.${sessionCode}`);
  }

  leaveBulkEditChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`bulk-edit.${tenant}.${sessionCode}`);
  }

  listenRenewalContractChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`bulk-renewal-contract.${tenant}.${sessionCode}`);
  }

  leaveRenewalContractChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`bulk-renewal-contract.${tenant}.${sessionCode}`);
  }

  listenBulkCancelChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`bulk-cancel.${tenant}.${sessionCode}`);
  }

  leaveBulkCancelChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`bulk-cancel.${tenant}.${sessionCode}`);
  }

  listenAddTeamMembersToTrainingChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`add-team-members-to-training.${tenant}`);
  }

  leaveAddTeamMembersToTrainingChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`add-team-members-to-training.${tenant}`);
  }

  listenImportCodaFileChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`import-coda-file.${tenant}.${sessionCode}`);
  }

  leaveImportCodaFileChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`import-coda-file.${tenant}.${sessionCode}`);
  }

  getStripeReportChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`export-generation.${tenant}.${sessionCode}`);
  }
  leaveStripeReportChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`export-generation.${tenant}.${sessionCode}`);
  }
  getAccessControlEventChangesChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`access-control-event-changes.${tenant}`);
  }
  getFmiChangesChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`fmi-changes.${tenant}`);
  }
  listenMergeContactsChannel(sessionCode): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.channel(`merge_contacts.${tenant}.${sessionCode}`);
  }

  leaveMergeContactsChannel(sessionCode) {
    const tenant = store.getters['tenant/selectedTenantId'];
    return window.Echo.leave(`merge_contacts.${tenant}.${sessionCode}`);
  }

  listenArticleImpactChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`article_impact.${tenant}.${sessionCode}`);
  }

  leaveArticleImpactChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`article_impact.${tenant}.${sessionCode}`);
  }

  listenResyncEntryChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`resync_entries.${tenant}.${sessionCode}`);
  }

  leaveResyncEntryChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`resync_entries.${tenant}.${sessionCode}`);
  }

  listenResyncSubscriptionChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`resync_subscriptions.${tenant}.${sessionCode}`);
  }

  leaveResyncSubscriptionChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`resync_subscriptions.${tenant}.${sessionCode}`);
  }

  listenRenewSubscriptionChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`renew_subscriptions.${tenant}.${sessionCode}`);
  }

  leaveRenewSubscriptionChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`renew_subscriptions.${tenant}.${sessionCode}`);
  }

  listenResyncAttendeesChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`resync_attendees.${tenant}.${sessionCode}`);
  }

  listenResyncActivitySessionsChannel(): Channel {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.channel(`resync_activity_sessions.${tenant}.${sessionCode}`);
  }

  leaveResyncAttendesChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`resync_attendees.${tenant}.${sessionCode}`);
  }

  leaveResyncActivitySessionsChannel() {
    const tenant = store.getters['tenant/selectedTenantId'];
    const sessionCode = store.getters['auth/user']?.id;
    return window.Echo.leave(`resync_attendees.${tenant}.${sessionCode}`);
  }
}
